const shortenUUID = (uuid: string): string => uuid.slice(0, uuid.indexOf('-'))

export default shortenUUID
